import Fuse from 'fuse.js'
const searchInput = document.querySelector('#search-input')
const searchTotal = document.querySelector('.search-total')
const suggestions = document.querySelector('.search-result')
const searchFilterItems = document.querySelectorAll('.search-filter-item')
const suggestionsContainer = document.querySelector('.search-result-container')
const closeSearchResult = document.querySelector('#close-search-result')
const popularProducts = document.querySelector('.search-popular-products')

// Check current language if WPML is active
// const currentLang = document.documentElement.lang;
// const cleanLang = currentLang.replace('-', '_');

// Check if dev
const devLocations = ['localhost', '.dev', '192.']
const isDev = devLocations.some((devLocation) => document.location.origin.includes(devLocation))

let endpoint

let fuse
if (isDev) {
    endpoint = `${document.location.origin}/torplyktan/search_result_sv_SE.json`
} else {
    endpoint = `${document.location.origin}/search_result_sv_SE.json`
}

fetch(endpoint)
    .then((blob) => blob.json())
    .then((datas) => {
        const search_list = [...datas].map((data) => {
            return data
        })
        const options = {
            // isCaseSensitive: false,
            includeScore: true,
            shouldSort: true,
            // includeMatches: true,
            // findAllMatches: false,
            minMatchCharLength: 2,
            // location: 0,
            threshold: 0.3,
            // distance: 100,
            useExtendedSearch: true,
            // ignoreLocation: false,
            // ignoreFieldNorm: false,
            keys: ['title', 'sku'],
        }
        fuse = new Fuse(search_list, options)
    })

function displayMatches(e) {
    let results
    results = fuse.search(searchInput.value)

    if (!results) {
        return
    }

    const searchItems = results
        .map((searchItem) => {
            // let res = results.total;

            return /*html*/ `
             <li class="search-item">
                 <a class="search-item-link" href="${searchItem.item.link}">
                    ${
                        searchItem.item.image
                            ? `<img src="${searchItem.item.image}">`
                            : `<span class="search-icon search-icon-${searchItem.item.type}"></span>`
                    }
                    <div class="d-block w-100">
                        <p class="search-item-name mb-0">${searchItem.item.title}</p>
                        <span class="woocommerce-Price-amount">${searchItem.item.price}</span>
                    </div>
                 </a>
             </li>
         `
        })
        .join('')
    suggestions.innerHTML = searchItems
    // searchTotal.innerHTML = `Totalt: ${results.total}`;

    if (searchInput.value.length > 1) {
        popularProducts.classList.add('hidden')
        suggestionsContainer.classList.add('show-suggestion')
        searchTotal.classList.add('show')
    } else {
        popularProducts.classList.remove('hidden')
        suggestionsContainer.classList.remove('show-suggestion')
        searchTotal.classList.remove('show')
    }
}

let searchWords
function setLatestSearch(e) {
    if (e.keyCode === 13 && searchInput.value.length > 0) {
        const searchContainer = {
            word: searchInput.value,
        }
        searchWords.push(searchContainer)
        localStorage.setItem('searchWord', JSON.stringify(searchWords))
    }
}

const latestSearchItems = document.querySelector('.latest-search-items')
function getLatestSearch() {
    if (localStorage.getItem('searchWord') !== null) {
        searchWords = JSON.parse(localStorage.getItem('searchWord'))

        const word = searchWords.slice(-5).map((searchWord) => {
            return `<div class="latest-word" data-id="${searchWord.word}">${searchWord.word}</div>`
        })
        latestSearchItems.innerHTML = word.join('')
    } else {
        searchWords = []
    }
}

document.addEventListener('DOMContentLoaded', getLatestSearch)
searchInput.addEventListener('keyup', setLatestSearch)

document.addEventListener('click', function (e) {
    if (e.target.id === 'search-input') {
        if (searchInput.value != '') {
            displayMatches(e)
        }
    }

    if (e.target.matches('#search-toggle')) {
        document.body.classList.add('search-open')
        searchInput.focus()
    }

    if (e.target.matches('#search-overlay')) {
        searchInput.value = ''
        document.body.classList.remove('search-open')
    }

    if (e.target.matches('.latest-word')) {
        let searchPath
        if (isDev) {
            searchPath = `${document.location.origin}/torplyktan/?s=${e.target.dataset.id}&post_type=product&search=on`
        } else {
            searchPath = `${document.location.origin}/?s=${e.target.dataset.id}&post_type=product&search=on`
        }
        window.location.assign(searchPath)
    }

    if (e.target.classList.contains('search-item-link')) {
        const name = e.target.querySelector('.search-item-name')
        const searchContainer = {
            word: name.textContent,
        }
        searchWords.push(searchContainer)
        localStorage.setItem('searchWord', JSON.stringify(searchWords))
    }

    if (e.target.classList.contains('clear-latest-search')) {
        if (localStorage.getItem('searchWord')) {
            localStorage.removeItem('searchWord')
            latestSearchItems.innerHTML = ''
        }
    }
})

export function closeSearch(e) {
    searchInput.value = ''
    // cleanSearchInput.classList.remove('show')
    return
}

searchInput.addEventListener('keyup', (e) => {
    if (e.keyCode === 27) {
        searchInput.blur()
        closeSearch(e)
    }
})

closeSearchResult.addEventListener('click', (e) => closeSearch(e))

searchFilterItems.forEach((filterItem) => filterItem.addEventListener('change', displayMatches))
searchInput.addEventListener('keyup', displayMatches)
